import { useResource } from "@/admin/useResource";
import {
  PageHeader,
  ResourceView,
  StatusBadge,
  fmtDate,
} from "@/admin/adminComponents";

const STATUS_OPTIONS = [
  { value: "approved", label: "Approved" },
  { value: "pending_approval", label: "Pending Approval" },
  { value: "suspended", label: "Suspended" },
];

const columns = [
  { key: "id", label: "ID", render: (r) => <span className="font-mono text-xs">{r.id}</span> },
  { key: "name", label: "Restaurant", render: (r) => <span className="font-medium text-halalgo-ink">{r.name}</span> },
  { key: "owner_name", label: "Owner" },
  { key: "city", label: "City" },
  { key: "cuisine", label: "Cuisine" },
  { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
  { key: "joined_at", label: "Joined", render: (r) => <span className="whitespace-nowrap text-xs">{fmtDate(r.joined_at)}</span> },
];

export default function Restaurants() {
  const { data, mocked, loading, refreshing, reload } = useResource("/restaurants", "restaurants");
  return (
    <div data-testid="admin-restaurants-page">
      <PageHeader title="Restaurants" subtitle="Halal-certified partner kitchens." mocked={mocked} />
      <ResourceView
        columns={columns}
        rows={data}
        loading={loading}
        testId="restaurants-table"
        exportName="restaurants"
        onRefresh={reload}
        refreshing={refreshing}
        searchPlaceholder="Search by name, owner, city, cuisine..."
        searchKeys={["id", "name", "owner_name", "city", "cuisine"]}
        filter={{ key: "status", placeholder: "Filter by status", allLabel: "All statuses", options: STATUS_OPTIONS }}
        detailTitle={(r) => r.name}
        detailSubtitle={(r) => `${r.cuisine} \u2022 ${r.city}`}
      />
    </div>
  );
}
